/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { AppraisalTranslation } from './';
import {
    AppraisalTranslationFromJSON,
    AppraisalTranslationFromJSONTyped,
    AppraisalTranslationToJSON,
} from './';
import type { CertificationTranslation } from './';
import {
    CertificationTranslationFromJSON,
    CertificationTranslationFromJSONTyped,
    CertificationTranslationToJSON,
} from './';
import type { EducationTranslation } from './';
import {
    EducationTranslationFromJSON,
    EducationTranslationFromJSONTyped,
    EducationTranslationToJSON,
} from './';
import type { ExperienceTranslation } from './';
import {
    ExperienceTranslationFromJSON,
    ExperienceTranslationFromJSONTyped,
    ExperienceTranslationToJSON,
} from './';
import type { RecommendationTranslation } from './';
import {
    RecommendationTranslationFromJSON,
    RecommendationTranslationFromJSONTyped,
    RecommendationTranslationToJSON,
} from './';
import type { SkillTranslation } from './';
import {
    SkillTranslationFromJSON,
    SkillTranslationFromJSONTyped,
    SkillTranslationToJSON,
} from './';

/**
 * 
 * @export
 * @interface ProfileTranslation
 */
export interface ProfileTranslation {
    /**
     * 
     * @type {string}
     * @memberof ProfileTranslation
     */
    headline?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileTranslation
     */
    description?: string;
    /**
     * 
     * @type {Array<SkillTranslation>}
     * @memberof ProfileTranslation
     */
    topSkills?: Array<SkillTranslation>;
    /**
     * 
     * @type {Array<SkillTranslation>}
     * @memberof ProfileTranslation
     */
    remainingSkills?: Array<SkillTranslation>;
    /**
     * 
     * @type {Array<ExperienceTranslation>}
     * @memberof ProfileTranslation
     */
    experiences?: Array<ExperienceTranslation>;
    /**
     * 
     * @type {Array<EducationTranslation>}
     * @memberof ProfileTranslation
     */
    educations?: Array<EducationTranslation>;
    /**
     * 
     * @type {Array<CertificationTranslation>}
     * @memberof ProfileTranslation
     */
    certifications?: Array<CertificationTranslation>;
    /**
     * 
     * @type {Array<AppraisalTranslation>}
     * @memberof ProfileTranslation
     */
    appraisals?: Array<AppraisalTranslation>;
    /**
     * 
     * @type {Array<RecommendationTranslation>}
     * @memberof ProfileTranslation
     */
    recommendations?: Array<RecommendationTranslation>;
}

/**
 * Check if a given object implements the ProfileTranslation interface.
 */
export function instanceOfProfileTranslation(value: object): value is ProfileTranslation {
    return true;
}

export function ProfileTranslationFromJSON(json: any): ProfileTranslation {
    return ProfileTranslationFromJSONTyped(json, false);
}

export function ProfileTranslationFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProfileTranslation {
    if (json == null) {
        return json;
    }
    return {
        
        'headline': json['headline'] == null ? undefined : json['headline'],
        'description': json['description'] == null ? undefined : json['description'],
        'topSkills': json['topSkills'] == null ? undefined : ((json['topSkills'] as Array<any>).map(SkillTranslationFromJSON)),
        'remainingSkills': json['remainingSkills'] == null ? undefined : ((json['remainingSkills'] as Array<any>).map(SkillTranslationFromJSON)),
        'experiences': json['experiences'] == null ? undefined : ((json['experiences'] as Array<any>).map(ExperienceTranslationFromJSON)),
        'educations': json['educations'] == null ? undefined : ((json['educations'] as Array<any>).map(EducationTranslationFromJSON)),
        'certifications': json['certifications'] == null ? undefined : ((json['certifications'] as Array<any>).map(CertificationTranslationFromJSON)),
        'appraisals': json['appraisals'] == null ? undefined : ((json['appraisals'] as Array<any>).map(AppraisalTranslationFromJSON)),
        'recommendations': json['recommendations'] == null ? undefined : ((json['recommendations'] as Array<any>).map(RecommendationTranslationFromJSON)),
    };
}

export function ProfileTranslationToJSON(value?: ProfileTranslation | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'headline': value['headline'],
        'description': value['description'],
        'topSkills': value['topSkills'] == null ? undefined : ((value['topSkills'] as Array<any>).map((v) => SkillTranslationToJSON(v))),
        'remainingSkills': value['remainingSkills'] == null ? undefined : ((value['remainingSkills'] as Array<any>).map((v) => SkillTranslationToJSON(v))),
        'experiences': value['experiences'] == null ? undefined : ((value['experiences'] as Array<any>).map((v) => ExperienceTranslationToJSON(v))),
        'educations': value['educations'] == null ? undefined : ((value['educations'] as Array<any>).map((v) => EducationTranslationToJSON(v))),
        'certifications': value['certifications'] == null ? undefined : ((value['certifications'] as Array<any>).map((v) => CertificationTranslationToJSON(v))),
        'appraisals': value['appraisals'] == null ? undefined : ((value['appraisals'] as Array<any>).map((v) => AppraisalTranslationToJSON(v))),
        'recommendations': value['recommendations'] == null ? undefined : ((value['recommendations'] as Array<any>).map((v) => RecommendationTranslationToJSON(v))),
    };
}

